__turbopack_context__.v({
  "container": "styles-module-scss-module__X-DRkG__container",
  "handle": "styles-module-scss-module__X-DRkG__handle",
  "header": "styles-module-scss-module__X-DRkG__header",
  "margin_top": "styles-module-scss-module__X-DRkG__margin_top",
  "range_slider_select": "styles-module-scss-module__X-DRkG__range_slider_select",
  "segment": "styles-module-scss-module__X-DRkG__segment",
  "select_container": "styles-module-scss-module__X-DRkG__select_container",
  "tick": "styles-module-scss-module__X-DRkG__tick",
  "tick_label": "styles-module-scss-module__X-DRkG__tick_label",
  "track": "styles-module-scss-module__X-DRkG__track",
});
